export class InitializableMap<K, V> extends Map<K, V> {
  public getOrInit(key: K, initialValue: V) {
    if (!this.has(key)) {
      this.set(key, initialValue)
    }
    return this.get(key)
  }
}
